import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b37ab1c6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37ab1c6')) {
      api.createRecord('b37ab1c6', component.options)
    } else {
      api.reload('b37ab1c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b37ab1c6", function () {
      api.rerender('b37ab1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/customerForecast/index.vue"
export default component.exports